/* global storeLocator */

document.addEventListener('DOMContentLoaded', () => {
  const statusElements = document.querySelectorAll('.js-store-status');
  const hourRows = document.querySelectorAll('.store__hours-row');

  // Helper functions
  function getClosingTime(hours, currentTime) {
    if (hours.includes('&')) {
      const [period1, period2] = hours.split('&');
      const [, end1] = period1.split('-');
      const [, end2] = period2.split('-');

      if (currentTime >= parseFloat(period1.split('-')[0]) && currentTime <= parseFloat(end1)) {
        return end1;
      }
      if (currentTime >= parseFloat(period2.split('-')[0]) && currentTime <= parseFloat(end2)) {
        return end2;
      }
    }
    const [, end] = hours.split('-');
    return end;
  }

  function checkIfOpen(hours, currentTime) {
    if (hours.includes('&')) {
      const [period1, period2] = hours.split('&');
      const [start1, end1] = period1.split('-');
      const [start2, end2] = period2.split('-');

      return (
        (currentTime >= parseFloat(start1) && currentTime <= parseFloat(end1)) ||
        (currentTime >= parseFloat(start2) && currentTime <= parseFloat(end2))
      );
    }
    const [start, end] = hours.split('-');
    return currentTime >= parseFloat(start) && currentTime <= parseFloat(end);
  }

  function decodeHtmlEntities(text) {
    const entities = {
      '&#39;': "'",
      '&quot;': '"',
      '&lt;': '<',
      '&gt;': '>',
      '&amp;': '&',
      '&apos;': "'",
    };
    return text.replace(/&#?\w+;/g, (match) => entities[match] || match);
  }

  function getOpeningTime(hours) {
    if (hours.includes('&')) {
      const [period1, period2] = hours.split('&');
      const [start1] = period1.split('-');
      const [start2] = period2.split('-');
      return parseFloat(start1) < parseFloat(start2) ? start1 : start2;
    }
    const [start] = hours.split('-');
    return start;
  }

  function formatTime(time) {
    const [hours, minutes = '00'] = time.toString().split('.');
    return `${hours}:${minutes.padEnd(2, '0')}`;
  }

  function updateOpeningHours() {
    // Get all exceptional openings and closings
    const exceptionalOpens = document.querySelectorAll('.js-exceptional-opens .exceptional-open');
    const exceptionalClosedDates = document.querySelectorAll(
      '.js-exceptional-closed .exceptional-closed',
    );

    // Process each day's row
    hourRows.forEach((row) => {
      const dateElement = row.querySelector('.store__day');
      const timeElement = row.querySelector('.store__time');
      const targetDate = dateElement.getAttribute('data-target-date');

      if (!targetDate) return;

      // Check for exceptional closures
      let isExceptionallyClosed = false;
      exceptionalClosedDates.forEach((closedDate) => {
        const cleanDate = closedDate.textContent.replace(/\s+/g, '');
        if (cleanDate === targetDate) {
          isExceptionallyClosed = true;
          timeElement.textContent =
            (storeLocator && storeLocator.Data && storeLocator.Data.exceptionallyClosed) ||
            'Exceptionally closed';
        }
      });

      // If not closed, check for exceptional openings
      if (!isExceptionallyClosed) {
        exceptionalOpens.forEach((exceptionalOpen) => {
          const [date, hours] = exceptionalOpen.textContent.split('|').map((s) => s.trim());
          const [day, month] = date.split(' ')[0].split('/');
          const exceptionalDate = `${day}/${month}/25`;

          if (exceptionalDate === targetDate) {
            timeElement.textContent = hours;
          }
        });
      }
    });
  }

  function updateStoreStatus() {
    statusElements.forEach((statusElement) => {
      const { hours } = statusElement.dataset;
      if (!hours) return;

      const storeContainer = statusElement.closest('.js-my-location-result');
      const storeId = storeContainer ? storeContainer.getAttribute('data-id') : null;

      const d = new Date();
      const time = parseFloat(`${d.getHours()}.${String(d.getMinutes()).padStart(2, '0')}`);
      const todayDateYY = `${String(d.getDate()).padStart(2, '0')}/${String(
        d.getMonth() + 1,
      ).padStart(2, '0')}/${String(d.getFullYear()).slice(-2)}`;

      const exceptionalClosedDates = document.querySelectorAll(
        '.js-exceptional-closed .exceptional-closed',
      );
      let isExceptionallyClosed = false;

      exceptionalClosedDates.forEach((closedDate) => {
        if (storeId && closedDate.getAttribute('data-store-id') && closedDate.getAttribute('data-store-id') !== storeId) return;
        const cleanDate = closedDate.textContent.replace(/\s+/g, '');
        if (cleanDate === todayDateYY) {
          isExceptionallyClosed = true;
        }
      });

      if (isExceptionallyClosed) {
        statusElement.classList.add('store--closed');
        statusElement.classList.remove('store--open');
        const exceptionallyClosedText = decodeHtmlEntities(
          (storeLocator && storeLocator.Data && storeLocator.Data.exceptionallyClosedToday) ||
            'Exceptionally closed today',
        );
        statusElement.querySelector('.store-status-text').textContent = exceptionallyClosedText;
        return;
      }

      const exceptionalOpens = document.querySelectorAll('.js-exceptional-opens .exceptional-open');
      let isExceptionallyOpen = false;
      let exceptionalClosingTime = null;

      exceptionalOpens.forEach((exceptionalOpen) => {
        if (storeId && exceptionalOpen.getAttribute('data-store-id') && exceptionalOpen.getAttribute('data-store-id') !== storeId) return;
        const [date, period] = exceptionalOpen.textContent.split('|');
        const cleanDate = date.replace(/\s+/g, '');

        if (cleanDate === todayDateYY) {
          const [start, end] = period.split('-').map((t) => t.trim());
          const startTime = parseFloat(start.replace(':', '.'));
          const endTime = parseFloat(end.replace(':', '.'));
          if (time >= startTime && time <= endTime) {
            isExceptionallyOpen = true;
            exceptionalClosingTime = end;
          }
        }
      });

      if (isExceptionallyOpen) {
        statusElement.classList.add('store--open');
        statusElement.classList.remove('store--closed');
        const nowExceptionallyOpen = decodeHtmlEntities(
          (storeLocator && storeLocator.Data && storeLocator.Data.nowExceptionallyOpen) ||
            'Now exceptionally open',
        );
        const untilText = decodeHtmlEntities(
          (storeLocator && storeLocator.Data && storeLocator.Data.untilText) || 'until',
        );
        statusElement.querySelector(
          '.store-status-text',
        ).textContent = `${nowExceptionallyOpen} ${untilText} ${exceptionalClosingTime}`;
        return;
      }

      // Check regular hours
      if (hours === 'closed' || hours === 'gesloten' || hours === 'fermé') {
        statusElement.classList.add('store--closed');
        statusElement.classList.remove('store--open');
        const nowClosed = decodeHtmlEntities(
          (storeLocator && storeLocator.Data && storeLocator.Data.nowClosed) || 'Now Closed',
        );
        statusElement.querySelector('.store-status-text').textContent = nowClosed;
        return;
      }

      const isOpen = checkIfOpen(hours, time);
      const closingTime = getClosingTime(hours, time);
      const openingTime = getOpeningTime(hours);

      if (isOpen) {
        statusElement.classList.add('store--open');
        statusElement.classList.remove('store--closed');
        const nowOpen = decodeHtmlEntities(
          (storeLocator && storeLocator.Data && storeLocator.Data.nowOpen) || 'Now Open',
        );
        const untilText = decodeHtmlEntities(
          (storeLocator && storeLocator.Data && storeLocator.Data.untilText) || 'until',
        );
        statusElement.querySelector(
          '.store-status-text',
        ).textContent = `${nowOpen} ${untilText} ${closingTime}`;
      } else {
        statusElement.classList.add('store--closed');
        statusElement.classList.remove('store--open');
        const closed = decodeHtmlEntities(
          (storeLocator && storeLocator.Data && storeLocator.Data.nowClosed) || 'Closed',
        );
        const opensAt = decodeHtmlEntities(
          (storeLocator && storeLocator.Data && storeLocator.Data.opensAt) || 'opens at',
        );
        const formattedOpeningTime = formatTime(openingTime);
        statusElement.querySelector(
          '.store-status-text',
        ).textContent = `${closed} – ${opensAt} ${formattedOpeningTime}`;
      }
    });
  }

  // Only run if we have status elements
  if (statusElements.length) {
    updateStoreStatus();
    updateOpeningHours();
    setInterval(() => {
      updateStoreStatus();
      updateOpeningHours();
    }, 60000);
  }
});
